import { render, staticRenderFns } from "./DashboardAdminSulteng.vue?vue&type=template&id=249031e4&lang=pug"
import script from "./DashboardAdminSulteng.vue?vue&type=script&lang=js"
export * from "./DashboardAdminSulteng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports